(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-ona-native-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  class StoreLocatorComponent extends HTMLElement {
    constructor() {
      super();
      this.listView = this.querySelector('.store-locator__list-view');
      this.detailView = this.querySelector('.store-locator__detail-view');
      this.cards = this.querySelectorAll('.store-locator__card');
      this.backButton = this.querySelector('.store-locator__back');
      this.directionsLink = this.querySelector('.store-locator__directions');
      this.bgImages = this.querySelectorAll('.store-locator__bg-image');
      this.defaultBgImage = this.querySelector('.store-locator__bg-image--default');
      
      this.detailName = this.querySelector('.store-locator__detail-name');
      this.detailAddress = this.querySelector('.store-locator__detail-address');
      this.detailPhoneWrap = this.querySelector('.store-locator__detail-phone');
      this.detailPhoneLink = this.querySelector('[data-detail-phone-link]');
      this.hoursRows = this.querySelectorAll('.store-locator__hours-row[data-day]');
      this.statusWrapper = this.querySelector('.store-locator__status-wrapper');
      this.statusBadge = this.querySelector('.store-locator__status');
      
      this.defaultImageIndex = parseInt(this.dataset.defaultImageIndex, 10);
      this.activeImageIndex = this.defaultImageIndex;
      this.lockedImageIndex = null;
      this.isDetailOpen = false;
      
      this.bindEvents();
      this.initCardStatuses();
    }

    initCardStatuses() {
      const sectionOpenBg = this.dataset.statusOpenBg;
      const sectionOpenText = this.dataset.statusOpenText;
      const sectionClosedBg = this.dataset.statusClosedBg;
      const sectionClosedText = this.dataset.statusClosedText;
      
      this.cards.forEach(card => {
        const cardStatusBadge = card.querySelector('[data-card-status]');
        if (!cardStatusBadge) return;
        
        const hoursData = card.dataset.storeHours;
        const showStatus = card.dataset.storeShowStatus === 'true';
        const closedText = card.dataset.storeClosedText;
        const openText = card.dataset.storeOpenText;
        
        if (!showStatus) {
          cardStatusBadge.style.display = 'none';
          return;
        }
        
        const hours = this.parseHours(hoursData);
        const isOpen = this.isCurrentlyOpen(hours);
        
        cardStatusBadge.textContent = isOpen ? openText : closedText;
        cardStatusBadge.style.backgroundColor = isOpen ? sectionOpenBg : sectionClosedBg;
        cardStatusBadge.style.color = isOpen ? sectionOpenText : sectionClosedText;
      });
    }

    bindEvents() {
      this.cards.forEach(card => {
        const viewDetailsBtn = card.querySelector('.store-locator__view-details');
        const cardButton = card.querySelector('.store-locator__card-button');
        const storeIndex = parseInt(card.dataset.storeIndex, 10);
        
        if (viewDetailsBtn) {
          viewDetailsBtn.addEventListener('click', () => this.showDetail(card));
        }
        
        if (cardButton) {
          cardButton.addEventListener('click', () => this.showDetail(card));
        }
        
        card.addEventListener('mouseenter', () => this.handleCardHover(storeIndex));
        card.addEventListener('mouseleave', () => this.handleCardLeave());
      });

      if (this.backButton) {
        this.backButton.addEventListener('click', () => this.showList());
      }
    }

    handleCardHover(storeIndex) {
      if (this.isDetailOpen) return;
      this.showImage(storeIndex);
    }

    handleCardLeave() {
      if (this.isDetailOpen) return;
      this.showImage(this.defaultImageIndex);
    }

    showImage(index) {
      this.bgImages.forEach(img => {
        const imgIndex = parseInt(img.dataset.bgIndex, 10);
        if (imgIndex === index) {
          img.classList.add('store-locator__bg-image--active');
          img.classList.remove('store-locator__bg-image--hidden');
        } else {
          img.classList.remove('store-locator__bg-image--active');
          if (imgIndex === -1) {
            img.classList.add('store-locator__bg-image--hidden');
          }
        }
      });
      
      if (index === -1 || !this.querySelector(`[data-bg-index="${index}"]`)) {
        if (this.defaultBgImage) {
          this.defaultBgImage.classList.add('store-locator__bg-image--active');
          this.defaultBgImage.classList.remove('store-locator__bg-image--hidden');
        }
      }
      
      this.activeImageIndex = index;
    }

    parseHours(hoursString) {
      const days = hoursString.split('|');
      return days.map(day => {
        const [from, to] = day.split(',');
        return { from: from || '', to: to || '' };
      });
    }

    formatTime(time) {
      if (!time) return '';
      const [hours, minutes] = time.split(':');
      const h = parseInt(hours, 10);
      const m = minutes || '00';
      return `${h}:${m.toString().padStart(2, '0')}`;
    }

    isClosed(from, to) {
      if (!from || !to) return true;
      if (from.toLowerCase() === 'closed' || to.toLowerCase() === 'closed') return true;
      if (!from.includes(':') || !to.includes(':')) return true;
      return false;
    }

    formatHoursRange(from, to, closedText) {
      if (this.isClosed(from, to)) return closedText;
      return `${this.formatTime(from)} - ${this.formatTime(to)}`;
    }

    isCurrentlyOpen(hours) {
      const now = new Date();
      const currentDay = (now.getDay() + 6) % 7;
      const todayHours = hours[currentDay];
      
      if (this.isClosed(todayHours.from, todayHours.to)) return false;
      
      const currentTime = now.getHours() * 60 + now.getMinutes();
      const [fromH, fromM] = todayHours.from.split(':').map(Number);
      const [toH, toM] = todayHours.to.split(':').map(Number);
      const openTime = fromH * 60 + (fromM || 0);
      const closeTime = toH * 60 + (toM || 0);
      
      return currentTime >= openTime && currentTime < closeTime;
    }

    getCurrentDay() {
      return (new Date().getDay() + 6) % 7;
    }

    showDetail(card) {
      const name = card.dataset.storeName;
      const address = card.dataset.storeAddress;
      const hoursData = card.dataset.storeHours;
      const showStatus = card.dataset.storeShowStatus === 'true';
      const closedText = card.dataset.storeClosedText;
      const openText = card.dataset.storeOpenText;
      const mapsUrl = card.dataset.storeMapsUrl;
      const phone = card.dataset.storePhone;
      const storeIndex = parseInt(card.dataset.storeIndex, 10);

      const sectionOpenBg = this.dataset.statusOpenBg;
      const sectionOpenText = this.dataset.statusOpenText;
      const sectionClosedBg = this.dataset.statusClosedBg;
      const sectionClosedText = this.dataset.statusClosedText;
      const highlightToday = this.dataset.highlightToday === 'true';

      this.detailName.textContent = name;
      this.detailAddress.textContent = address;

      if (this.detailPhoneWrap && this.detailPhoneLink) {
        if (phone) {
          this.detailPhoneLink.textContent = phone;
          this.detailPhoneLink.href = 'tel:' + phone.replace(/\s+/g, '');
          this.detailPhoneWrap.hidden = false;
        } else {
          this.detailPhoneLink.textContent = '';
          this.detailPhoneLink.href = '#';
          this.detailPhoneWrap.hidden = true;
        }
      }
      
      const hours = this.parseHours(hoursData);
      const currentDay = this.getCurrentDay();
      
      this.hoursRows.forEach(row => {
        const dayIndex = parseInt(row.dataset.day, 10);
        const dayHours = hours[dayIndex];
        const timeEl = row.querySelector('.store-locator__hours-time');
        
        if (timeEl) {
          timeEl.textContent = this.formatHoursRange(dayHours.from, dayHours.to, closedText);
        }
        
        row.classList.remove('store-locator__hours-row--today');
        if (highlightToday && dayIndex === currentDay) {
          row.classList.add('store-locator__hours-row--today');
        }
      });
      
      if (showStatus && this.statusWrapper && this.statusBadge) {
        const isOpen = this.isCurrentlyOpen(hours);
        this.statusBadge.textContent = isOpen ? openText : closedText;
        this.statusBadge.style.backgroundColor = isOpen ? sectionOpenBg : sectionClosedBg;
        this.statusBadge.style.color = isOpen ? sectionOpenText : sectionClosedText;
        this.statusWrapper.hidden = false;
      } else if (this.statusWrapper) {
        this.statusWrapper.hidden = true;
      }
      
      if (mapsUrl) {
        this.directionsLink.href = mapsUrl;
        this.directionsLink.style.display = '';
      } else {
        this.directionsLink.style.display = 'none';
      }

      this.lockedImageIndex = storeIndex;
      this.isDetailOpen = true;
      this.showImage(storeIndex);

      this.listView.hidden = true;
      this.detailView.hidden = false;
      this.classList.add('store-locator--detail-open');
    }

    showList() {
      this.lockedImageIndex = null;
      this.isDetailOpen = false;
      this.showImage(this.defaultImageIndex);

      this.listView.hidden = false;
      this.detailView.hidden = true;
      this.classList.remove('store-locator--detail-open');
    }
  }

  customElements.define('store-locator-component', StoreLocatorComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  class TimelineSection extends HTMLElement {
    connectedCallback() {
      this._raf = requestAnimationFrame(() => this.init());
    }

    init() {
      this.stepEls = [...this.querySelectorAll('[data-tl-step]')];
      if (this.stepEls.length === 0) return;
      this.activeIndex = -1;
      this.count = this.stepEls.length;

      if (window.innerWidth >= 750) {
        this.setupDesktop();
      } else {
        this.setupMobile();
      }
    }

    setupDesktop() {
      const count = this.count;

      // Build layout
      const wrapper = document.createElement('div');
      wrapper.className = 'tl__wrapper';
      const inner = document.createElement('div');
      inner.className = 'tl__inner spacing-style';
      inner.style.cssText = this.style.cssText;
      const colLeft = document.createElement('div');
      colLeft.className = 'tl__left';
      const colRight = document.createElement('div');
      colRight.className = 'tl__right';
      colRight.style.position = 'relative';

      this.leftItems = [];
      this.rightPanels = [];

      // Create offscreen measurer
      const measurer = document.createElement('div');
      measurer.style.cssText = 'position:fixed;top:-9999px;left:-9999px;visibility:hidden;pointer-events:none;';
      document.body.appendChild(measurer);

      // We need colLeft in DOM to measure its width
      inner.appendChild(colLeft);
      inner.appendChild(colRight);
      wrapper.appendChild(inner);
      this.appendChild(wrapper);
      this.classList.add('tl--ready');
      const colLeftW = colLeft.offsetWidth;

      this.stepEls.forEach((step, i) => {
        const pill = step.querySelector('.tl-step__pill');
        const content = step.querySelector('.tl-step__content');
        const right = step.querySelector('.tl-step__right');

        // Read pill styling from data attributes
        const pillBg = step.dataset.pillBg || '';
        const pillPadding = parseInt(step.dataset.pillPadding) || 0;
        const pillRadius = parseInt(step.dataset.pillRadius) || 0;

        // Build left item with pill styling
        const leftItem = document.createElement('div');
        leftItem.className = 'tl__left-item';
        if (pillBg) leftItem.classList.add('color-' + pillBg);
        leftItem.dataset.index = i;
        if (pillPadding) leftItem.style.padding = pillPadding + 'px';
        if (pillRadius) leftItem.style.borderRadius = pillRadius + 'px';

        // Clone pill and content into left item
        if (pill) leftItem.appendChild(pill.cloneNode(true));
        if (content && content.innerHTML.trim()) {
          const contentClone = content.cloneNode(true);
          leftItem.appendChild(contentClone);
        }

        // Measure using offscreen clone — capped to column width
        const measureClone = leftItem.cloneNode(true);
        measureClone.style.maxWidth = colLeftW + 'px';
        const measureContent = measureClone.querySelector('.tl-step__content');

        // Pill size: content completely removed from layout
        if (measureContent) {
          measureContent.style.display = 'none';
        }
        measurer.appendChild(measureClone);
        const pillW = measureClone.offsetWidth;
        const pillH = measureClone.offsetHeight;

        // Expanded size: content shown, capped to column
        if (measureContent) {
          measureContent.style.display = '';
          measureContent.style.height = 'auto';
        }
        const expandedW = Math.min(measureClone.offsetWidth, colLeftW);
        const expandedH = measureClone.offsetHeight;
        measurer.removeChild(measureClone);

        leftItem._pillW = pillW;
        leftItem._pillH = pillH;
        leftItem._expandedW = expandedW;
        leftItem._expandedH = expandedH;
        leftItem._contentEl = leftItem.querySelector('.tl-step__content');

        // Set content to fixed min-width so text never reflows during animation
        // Parent overflow:hidden clips it — content stays laid out at full size
        if (leftItem._contentEl) {
          const contentW = expandedW - (pillPadding * 2);
          leftItem._contentEl.style.minWidth = contentW + 'px';
          leftItem._contentEl.style.width = contentW + 'px';
          leftItem._contentEl.style.flexShrink = '0';
          leftItem._contentEl.style.height = '0';
          leftItem._contentEl.style.overflow = 'hidden';
        }
        leftItem.style.width = pillW + 'px';
        leftItem.style.height = pillH + 'px';

        colLeft.appendChild(leftItem);
        this.leftItems.push(leftItem);

        // Build right panel
        const rightPanel = document.createElement('div');
        rightPanel.className = 'tl__right-panel';
        if (right) rightPanel.innerHTML = right.innerHTML;
        colRight.appendChild(rightPanel);
        this.rightPanels.push(rightPanel);

        // Click
        leftItem.addEventListener('click', () => this.setActive(i));
      });

      document.body.removeChild(measurer);

      this.setActive(0);

      // Scroll progress
      this._onScroll = () => {
        const rect = wrapper.getBoundingClientRect();
        const scrolled = -rect.top;
        const scrollRange = rect.height - window.innerHeight;
        if (scrollRange <= 0) return;
        const progress = Math.max(0, Math.min(1, scrolled / scrollRange));
        const stepIndex = Math.min(count - 1, Math.floor(progress * count));
        this.setActive(stepIndex);
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }

    setupMobile() {
      const pills = document.createElement('div');
      pills.className = 'tl__pills';
      const swipe = document.createElement('div');
      swipe.className = 'tl__swipe';
      const track = document.createElement('div');
      track.className = 'tl__track';

      this.mobilePills = [];
      this.mobileSlides = [];

      this.stepEls.forEach((step, i) => {
        const pill = step.querySelector('.tl-step__pill');
        const right = step.querySelector('.tl-step__right');

        // Pill clone
        const pillClone = document.createElement('div');
        if (pill) pillClone.innerHTML = pill.innerHTML;
        pillClone.style.display = 'flex';
        pillClone.style.alignItems = 'center';
        pillClone.style.gap = '12px';
        pillClone.style.whiteSpace = 'nowrap';
        pillClone.addEventListener('click', () => this.setActive(i));
        pills.appendChild(pillClone);
        this.mobilePills.push(pillClone);

        // Slide
        const slide = document.createElement('div');
        if (right) slide.innerHTML = right.innerHTML;
        track.appendChild(slide);
        this.mobileSlides.push(slide);
      });

      swipe.appendChild(track);
      this.appendChild(pills);
      this.appendChild(swipe);
      this.classList.add('tl--ready');
      this._track = track;

      this.setActive(0);

      // Touch swipe
      let startX = 0, startY = 0, isDragging = false, isHorizontal = null;
      swipe.addEventListener('touchstart', e => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
        isHorizontal = null;
        track.classList.add('tl__track--swiping');
      }, { passive: true });

      swipe.addEventListener('touchmove', e => {
        if (!isDragging) return;
        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;
        if (isHorizontal === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
          isHorizontal = Math.abs(dx) > Math.abs(dy);
        }
        if (!isHorizontal) return;
        e.preventDefault();
        const offset = -(this.activeIndex * 100) + (dx / swipe.offsetWidth) * 100;
        track.style.transform = `translateX(${offset}%)`;
      }, { passive: false });

      swipe.addEventListener('touchend', e => {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('tl__track--swiping');
        if (!isHorizontal) { this.slideTo(this.activeIndex); return; }
        const dx = e.changedTouches[0].clientX - startX;
        const threshold = swipe.offsetWidth * 0.2;
        if (dx < -threshold && this.activeIndex < this.count - 1) {
          this.setActive(this.activeIndex + 1);
        } else if (dx > threshold && this.activeIndex > 0) {
          this.setActive(this.activeIndex - 1);
        } else {
          this.slideTo(this.activeIndex);
        }
      }, { passive: true });
    }

    slideTo(index) {
      if (this._track) this._track.style.transform = `translateX(-${index * 100}%)`;
    }

    setActive(index) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;

      // Desktop left items — animate width/height
      if (this.leftItems) {
        this.leftItems.forEach((el, i) => {
          const isActive = i === index;
          el.classList.toggle('tl--active', isActive);

          if (el._anim) { el._anim.cancel(); el._anim = null; }

          const toW = isActive ? el._expandedW : el._pillW;
          const toH = isActive ? el._expandedH : el._pillH;
          const contentEl = el._contentEl;

          // Show content before expanding so box grows around it
          if (isActive && contentEl) {
            contentEl.style.height = 'auto';
            contentEl.style.overflow = '';
          }

          const fromW = el.offsetWidth;
          const fromH = el.offsetHeight;

          // Set final state
          el.style.width = toW + 'px';
          el.style.height = toH + 'px';

          // Animate
          if (fromW !== toW || fromH !== toH) {
            el._anim = el.animate(
              [
                { width: fromW + 'px', height: fromH + 'px' },
                { width: toW + 'px', height: toH + 'px' }
              ],
              { duration: 500, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
            );
            el._anim.onfinish = () => {
              el._anim = null;
              if (!isActive && contentEl) {
                contentEl.style.height = '0';
                contentEl.style.overflow = 'hidden';
              }
            };
          } else if (!isActive && contentEl) {
            contentEl.style.height = '0';
            contentEl.style.overflow = 'hidden';
          }
        });
      }

      // Desktop right panels
      if (this.rightPanels) {
        this.rightPanels.forEach((el, i) => el.classList.toggle('tl--active', i === index));
      }

      // Mobile pills
      if (this.mobilePills) {
        this.mobilePills.forEach((el, i) => el.classList.toggle('tl--active', i === index));
      }

      // Mobile track
      this.slideTo(index);
    }

    disconnectedCallback() {
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._raf) cancelAnimationFrame(this._raf);
    }
  }

  if (!customElements.get('timeline-section')) {
    customElements.define('timeline-section', TimelineSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vasky-stores"] && !Shopify.designMode) return;
  try {
    
// Use the store's timezone, never the visitor's local timezone.
function vaskyStoreHoursState(hours, now = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Prague', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now).map(p => [p.type, p.value]));
  const day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(parts.weekday);
  const minutes = Number(parts.hour) * 60 + Number(parts.minute);
  const parse = value => /^\d{1,2}:\d{2}$/.test(value || '') ? Number(value.split(':')[0]) * 60 + Number(value.split(':')[1]) : null;
  const [from, to] = hours[day] || [];
  const start = parse(from), end = parse(to);
  const valid = start !== null && end !== null && start < 1440 && end < 1440 && start !== end;
  const previous = hours[(day + 6) % 7] || [];
  const previousStart = parse(previous[0]), previousEnd = parse(previous[1]);
  if (previousStart !== null && previousEnd !== null && previousStart > previousEnd && minutes < previousEnd) return { day, open: true, text: `Otevřeno do ${previous[1]}` };
  if (valid && minutes >= start && (end > start ? minutes < end : true)) return { day, open: true, text: `Otevřeno do ${to}` };
  if (valid && minutes < start) return { day, open: false, text: `Dnes otevřeno ${from}–${to}` };
  const tomorrow = hours[(day + 1) % 7] || [];
  const tomorrowStart = parse(tomorrow[0]), tomorrowEnd = parse(tomorrow[1]);
  const next = tomorrowStart !== null && tomorrowEnd !== null && tomorrowStart !== tomorrowEnd;
  return { day, open: false, text: next ? `Zavřeno · zítra od ${tomorrow[0]}` : 'Dnes zavřeno' };
}
function vaskyStoreDistance(a, b) {
  const rad = n => n * Math.PI / 180;
  const h = Math.sin(rad(b[0] - a[0]) / 2) ** 2 + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(rad(b[1] - a[1]) / 2) ** 2;
  return 6371 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(Math.max(0, 1 - h)));
}
class VaskyStores extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.controller = new AbortController();
    this.stores = Array.from(this.querySelectorAll('[data-store]'));
    this.grid = this.querySelector('[data-grid]');
    this.city = this.querySelector('select[data-city]');
    this.updateHours();
    this.timer = setInterval(() => this.updateHours(), 60000);
    if (!this.grid) {
      // The theme wrapper clips fixed descendants; keep the mobile actions at body level.
      this.mobileBar = document.createElement('div');
      this.mobileBar.className = 'vs vs-floating color-' + this.dataset.colorScheme;
      this.mobileBar.setAttribute('role', 'navigation');
      this.mobileBar.setAttribute('aria-label', 'Kontakt prodejny');
      this.mobileBar.append(this.querySelector('.vs-detail-actions').cloneNode(true));
      document.body.append(this.mobileBar);
      return;
    }
    this.querySelector('[data-controls]').hidden = false;
    [...new Set(this.stores.map(s => s.dataset.city))].sort((a,b) => a.localeCompare(b,'cs')).forEach(city => this.city.add(new Option(city, city)));
    const pills=this.querySelector('[data-city-pills]');
    [...this.city.options].forEach(option=>{
      const button=document.createElement('button');button.type='button';button.className='vs-city-pill';button.dataset.cityValue=option.value;button.textContent=option.value||'Všechny';button.setAttribute('aria-pressed','false');
      button.addEventListener('click',()=>{this.city.value=option.value;this.city.dispatchEvent(new Event('change'));},{signal:this.controller.signal});pills.append(button);
    });
    this.querySelector('.vs-city-label').hidden=true;
    const cityParam = new URL(location.href).searchParams.get('mesto');
    if ([...this.city.options].some(o => o.value === cityParam)) this.city.value = cityParam;
    this.city.addEventListener('change', () => {
      const url = new URL(location.href);
      this.city.value ? url.searchParams.set('mesto', this.city.value) : url.searchParams.delete('mesto');
      history.replaceState(null, '', url);
      this.filter();
    }, {signal:this.controller.signal});
    this.querySelector('[data-reset]').addEventListener('click', () => { this.city.value=''; this.city.dispatchEvent(new Event('change')); }, {signal:this.controller.signal});
    this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => this.setView(button.dataset.view), {signal:this.controller.signal}));
    this.querySelector('[data-nearest]').addEventListener('click', () => this.nearest(), {signal:this.controller.signal});
    this.filter();
  }
  disconnectedCallback() { clearInterval(this.timer); this.mobileBar?.remove(); this.controller?.abort(); this.map?.remove(); this.map=null; this.ready=false; }
  updateHours() {
    this.stores.forEach(store => {
      const state = vaskyStoreHoursState(store.dataset.hours.split(';').map(d=>d.split(',')));
      const status = store.querySelector('[data-status]');
      status.hidden = store.dataset.showStatus === 'false';
      if (store.dataset.closed === 'true') { status.textContent='Dočasně zavřeno'; status.dataset.state='closed'; }
      else if (store.dataset.notice) { status.textContent='Otevírací doba: viz upozornění'; status.removeAttribute('data-state'); }
      else { status.textContent=state.text; status.dataset.state=state.open?'open':'closed'; }
      store.querySelectorAll('[data-day]').forEach(row=>row.toggleAttribute('data-today', Number(row.dataset.day)===state.day));
    });
  }
  filter() {
    this.querySelectorAll('[data-city-value]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.cityValue===this.city.value)));
    const pills=this.querySelector('[data-city-pills]'), active=pills?.querySelector('[aria-pressed="true"]');
    if(active && pills.scrollWidth>pills.clientWidth)pills.scrollLeft+=active.getBoundingClientRect().left-pills.getBoundingClientRect().left-8;
    this.stores.forEach(s=>s.hidden=!!this.city.value && s.dataset.city!==this.city.value);
    this.visible=this.stores.filter(s=>!s.hidden);
    const n=this.visible.length;
    this.querySelector('[data-count]').textContent=`${n} ${n===1?'prodejna':n<5?'prodejny':'prodejen'}`;
    this.querySelector('[data-reset]').hidden=!this.city.value;
    this.updateMap();
  }
  message(text) { const el=this.querySelector('[data-message]'); el.textContent=text; el.hidden=!text; }
  nearest() {
    if (!navigator.geolocation) { this.message('Prohlížeč neumí zjistit polohu. Vyberte město ze seznamu.'); return; }
    const button=this.querySelector('[data-nearest]'); button.disabled=true; button.textContent='Zjišťuji polohu…';
    navigator.geolocation.getCurrentPosition(position=>{
      if(!this.isConnected)return;
      const origin=[position.coords.latitude,position.coords.longitude];
      this.stores.forEach(s=>{
        s.distance=vaskyStoreDistance(origin,[Number(s.dataset.lat),Number(s.dataset.lng)]);
        const label=s.querySelector('[data-distance]');label.textContent=`${s.distance.toLocaleString('cs-CZ',{maximumFractionDigits:1})} km`;label.hidden=false;
      });
      this.stores.sort((a,b)=>a.distance-b.distance).forEach(s=>this.grid.append(s));
      this.city.value=''; this.city.dispatchEvent(new Event('change'));
      this.message('Seřazeno podle vzdálenosti vzdušnou čarou.');button.disabled=false;button.textContent='Najít nejbližší ↗';
    },error=>{
      if(!this.isConnected)return;
      this.message(error.code===1?'Poloha není povolená. Vyberte město ze seznamu.':'Polohu se nepodařilo zjistit. Vyberte město ze seznamu.');
      button.disabled=false;button.textContent='Najít nejbližší ↗';
    },{enableHighAccuracy:false,timeout:10000,maximumAge:60000});
  }
  async setView(view) {
    this.querySelectorAll('[data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===view)));
    const panel=this.querySelector('[data-map-panel]');panel.hidden=view!=='map';
    if(view!=='map')return;
    try {
      await this.loadLeaflet();
      if(!this.isConnected || panel.hidden)return;
      this.querySelector('[data-map-error]').hidden=true;
      if(!this.map){
        this.map=window.L.map(this.querySelector('[data-map]'),{scrollWheelZoom:false});
        window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:19,attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(this.map);
        this.markers=window.L.layerGroup().addTo(this.map);
      }
      this.map.invalidateSize();this.updateMap();
    }catch{this.querySelector('[data-map-error]').hidden=false;}
  }
  updateMap() {
    if(!this.map)return;
    this.markers.clearLayers(); const points=[];
    this.visible.forEach((store,index)=>{
      const lat=Number(store.dataset.lat),lng=Number(store.dataset.lng);
      if(!Number.isFinite(lat)||!Number.isFinite(lng)||!lat||!lng)return;
      points.push([lat,lng]);
      const popup=document.createElement('div');
      const title=document.createElement('strong');title.textContent=store.querySelector('h2').textContent;
      const address=document.createElement('p');address.textContent=store.querySelector('.vs-address').textContent;
      const link=store.querySelector('[data-detail-link]').cloneNode(true);link.textContent='Detail prodejny →';
      popup.append(title,address,link);
      const icon=window.L.divIcon({className:'vs-marker',html:String(index+1),iconSize:[30,30],iconAnchor:[15,15]});
      window.L.marker([lat,lng],{icon,title:title.textContent,alt:title.textContent}).bindPopup(popup).addTo(this.markers);
    });
    if(points.length)this.map.fitBounds(points,{padding:[40,40],maxZoom:13});
  }
  loadLeaflet() {
    if(window.L)return Promise.resolve();
    if(window.vaskyLeafletPromise)return window.vaskyLeafletPromise;
    window.vaskyLeafletPromise=new Promise((resolve,reject)=>{
      const css=document.createElement('link');css.rel='stylesheet';css.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';css.integrity='sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';css.crossOrigin='';document.head.append(css);
      const script=document.createElement('script');script.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';script.integrity='sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';script.crossOrigin='';
      script.onload=resolve;script.onerror=()=>{window.vaskyLeafletPromise=null;script.remove();css.remove();reject(new Error('Map unavailable'));};document.head.append(script);
    });return window.vaskyLeafletPromise;
  }
}
if(!customElements.get('vasky-stores'))customElements.define('vasky-stores',VaskyStores);


  } catch(e) { console.error(e); }
})();
})();
